//export const API_URL = 'http://localhost:5000/';
//export const API_URL = 'https://t3-api.greduation.com/';   /// Stagging
//export const API_URL = 'https://t4-demo-api.techwagger.com/';    /// Demo 
//export const API_URL = 'https://api.t3amb.info/';    /// Production
//export const API_URL = 'http://13.202.183.134:8081/';    /// testing
export const API_URL = 'https://api.anemiamuktbharatelearning.org/';    /// testing aduit



